import HttpClientXml from "../utils/HttpClientXml";

// >>>All GET Api<<<
const getPropertyTypes = async () => {
  let endPoint = "property-type-list";
  return HttpClientXml.get(endPoint);
};
const getCitiesForUser = async () => {
  let endPoint = "all-city-list";
  return HttpClientXml.get(endPoint);
};
const getBlogs = async (blogFetchCount) => {
  let endPoint = `blog?limit=${blogFetchCount}`;
  // let endPoint = `blog?limit=6`;
  return HttpClientXml.get(endPoint);
};

const getBhks = async () => {
  let endPoint = "bhk-list";
  return HttpClientXml.get(endPoint);
};
const getFloors = async () => {
  let endPoint = "floor-list";
  return HttpClientXml.get(endPoint);
};
const getLoginProfile = async () => {
  let endPoint = "get-profile";
  return HttpClientXml.get(endPoint);
};

const getUsers = async () => {
  // let endPoint = "user-list";
  let endPoint = "user-list-with-fav-flag";
  return HttpClientXml.get(endPoint);
};
const getProfile = async () => {
  // let endPoint = "get-profile";
  let endPoint = "get-profile-details";
  return HttpClientXml.get(endPoint);
};
const getBanner = async () => {
  let endPoint = "banner-list";
  return HttpClientXml.get(endPoint);
};
const getAllAdvertisement = async () => {
  let endPoint = "advertisement-list";
  return HttpClientXml.get(endPoint);
};
const propertyInHand = async (id) => {
  let endPoint = `property-in-hand${id}`;
  return HttpClientXml.get(endPoint);
};
const getAllCityList = async () => {
  let endPoint = `all-city-list`;
  return HttpClientXml.get(endPoint);
};
const fetchAllProperty = async (id) => {
  let endPoint = `/property-in-hand/${id}`;
  return HttpClientXml.get(endPoint);
};

// >>>All POST<<<
const addCity = async (data) => {
  let endPoint = "city";
  return HttpClientXml.post(endPoint, data);
};

const addRemarks = async (data) => {
  let endPoint = "add-remarks";
  return HttpClientXml.post(endPoint, data);
};
const addHotClient = async (data) => {
  let endPoint = "hot-client";
  return HttpClientXml.post(endPoint, data);
};
const addContactUs = async (data) => {
  let endPoint = "contact-us";
  return HttpClientXml.post(endPoint, data);
};

const addPropertyType = async (data) => {
  let endPoint = "property-type";
  return HttpClientXml.post(endPoint, data);
};
const addBhk = async (data) => {
  let endPoint = "bhk";
  return HttpClientXml.post(endPoint, data);
};
const addFloor = async (data) => {
  let endPoint = "floor";
  return HttpClientXml.post(endPoint, data);
};
const addProperty = async (data) => {
  let endPoint = "property";
  return HttpClientXml.post(endPoint, data);
};
const verifyEmail = async (data) => {
  let endPoint = "verify-email";
  return HttpClientXml.post(endPoint, data);
};
const getProperties = async (data) => {
  let endPoint = "property";
  return HttpClientXml.post(endPoint, data);
};
const getCities = async (data) => {
  let endPoint = "city-list";
  return HttpClientXml.post(endPoint, data);
};
const getFilteredPropertyList = async (data) => {
  let endPoint = "filter-property";
  return HttpClientXml.post(endPoint, data);
};
const getPropertyList = async (data) => {
  let endPoint = "filter-property-by-fields";
  return HttpClientXml.post(endPoint, data);
};
const addToWishList = async (data) => {
  let endPoint = "favourite-property";
  return HttpClientXml.post(endPoint, data);
};
const postPropertyInHand = async (data) => {
  let endPoint = "property-in-hand";
  return HttpClientXml.post(endPoint, data);
};
const postClientInHandRequirement = async (data) => {
  let endPoint = "client-in-hand";
  return HttpClientXml.post(endPoint, data);
};

const fetchPropertyInHand = async (id) => {
  let endPoint = `property-in-hand/${id}`;
  return HttpClientXml.get(endPoint);
};
const getClientInHand = async () => {
  let endPoint = "client-in-hand";
  return HttpClientXml.get(endPoint);
};
const getClientInHandById = async (id) => {
  let endPoint = `client-in-hand/${id}`;
  return HttpClientXml.get(endPoint);
};
const getFacings = async () => {
  let endPoint = "facing-list";
  return HttpClientXml.get(endPoint);
};

// >>>All PUT Api<<<
const updateCity = async (id, data) => {
  let endPoint = `city/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updatePropertyType = async (id, data) => {
  let endPoint = `property-type/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateBhk = async (id, data) => {
  let endPoint = `bhk/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateFloor = async (id, data) => {
  let endPoint = `floor/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateProperty = async (id, data) => {
  let endPoint = `property/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updatePropertyStatus = async (id, data) => {
  let endPoint = `change-status-property/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateUserStatus = async (id, data) => {
  let endPoint = `user-status-change/${id}`;
  return HttpClientXml.put(endPoint, data);
};
const updateProfile = async (data) => {
  let endPoint = `update-profile`;
  return HttpClientXml.put(endPoint, data);
};

// >>>All DELETE Api<<<
const deleteCity = async (id, data) => {
  let endPoint = `city/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deletePropertyType = async (id, data) => {
  let endPoint = `property-type/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteBhk = async (id, data) => {
  let endPoint = `bhk/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteFloor = async (id, data) => {
  let endPoint = `floor/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};
const deleteProperty = async (id, data) => {
  let endPoint = `property/${id}`;
  return HttpClientXml.deletemethod(endPoint, data);
};

const getJobCategories = async () => {
  let endPoint = "get-job-category-post";
  return HttpClientXml.get(endPoint);
}

const getJobPostsByCategoryId = async (id) => {
  let endPoint = `get-job-post/${id}`;
  return HttpClientXml.get(endPoint);
}

const applyJob = async (data) => {
  let endPoint = "job-apply";
  return HttpClientXml.post(endPoint, data);
};

const getLocalitiesByCity = async (id) => {
  let endPoint = `locality-list/${id}`;
  return HttpClientXml.get(endPoint);
};

const getBlogCategoryList = async () => {
  let endPoint = "blog-category";
  return HttpClientXml.get(endPoint);
};

const getLocalitiesByCityWithoutAuth = async (id) => {
  let endPoint = `locality-lists-by-serach/${id}`;
  return HttpClientXml.get(endPoint);
};
const getPropertyTypesWithoutAuth = async () => {
  let endPoint = "property-type-lists";
  return HttpClientXml.get(endPoint);
};

const makeFavouriteCommunity = async (data) => {
  let endPoint = "favourite-community";
  return HttpClientXml.post(endPoint, data);
};
const getFavCommunities = async () => {
  let endPoint = "favourite-community";
  return HttpClientXml.get(endPoint);
};
const getAllPropertyList = async (data) => {
  let endPoint = "filter-property-by-fields-with-status";
  return HttpClientXml.post(endPoint, data);
};

export default {
  getAllPropertyList,
  getFavCommunities,
  makeFavouriteCommunity,
  getPropertyTypesWithoutAuth,
  getLocalitiesByCityWithoutAuth,
  getBlogCategoryList,
  getLocalitiesByCity,
  applyJob,
  
  getJobPostsByCategoryId,
  getJobCategories,
  // >>>GET<<<
  getClientInHandById,
  getCitiesForUser,
  getBlogs,

  getPropertyTypes,
  getBhks,
  getFloors,
  getLoginProfile,
  getUsers,
  getProfile,
  getBanner,
  getAllAdvertisement,
  propertyInHand,
  fetchAllProperty,
  getAllCityList,

  // >>>POST<<<
  addCity,
  addPropertyType,
  addRemarks,
  addContactUs,
  addHotClient,
  addBhk,
  addFloor,
  addProperty,
  verifyEmail,
  getProperties,
  getCities,
  getFilteredPropertyList,
  getPropertyList,
  addToWishList,
  fetchPropertyInHand,
  getClientInHand,
  getFacings,

  postPropertyInHand,
  postClientInHandRequirement,

  // >>>PUT<<<
  updateCity,
  updatePropertyType,
  updateBhk,
  updateFloor,
  updateProperty,
  updatePropertyStatus,
  updateUserStatus,
  updateProfile,
  // >>>DELETE<<<
  deleteCity,
  deletePropertyType,
  deleteBhk,
  deleteFloor,
  deleteProperty,
};
